import styled from 'styled-components';

export const WizardFormWrapperStyled = styled.form`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

export const WizardFormProgressStyled = styled.div`
  position: relative;
  margin-bottom: 16px;
`;

export const WizardFormContentStyled = styled.div`
  position: relative;
  padding: 20px 0;

  ${({ fillPageArea }) => (fillPageArea ? 'min-height: 200px;' : '')}
`;

export const WizardFormNavigationStyled = styled.div`
  position: relative;
  margin-bottom: 24px;
`;
